import { deepCopyUtil } from "../util/util";

export interface Beepers {
  beepers: number[][];
  equals(other: Beepers): boolean;
  beeperPresent(r: number, c: number): boolean;
  putBeeper(r: number, c: number): void;
  pickBeeper(r: number, c: number): void;
  getNumBeepers(r: number, c: number): number;
  deepCopy(): Beepers;
}

export function Beepers(rows: number, cols: number): Beepers {
  const that: Beepers = {
    beepers: [],

    equals(other: Beepers): boolean {
      for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols; j++) {
          if (that.beepers[i][j] !== other.beepers[i][j]) return false;
        }
      }
      return true;
    },

    beeperPresent(r: number, c: number): boolean {
      return that.beepers[r][c] > 0;
    },

    putBeeper(r: number, c: number): void {
      that.beepers[r][c] = that.beepers[r][c] + 1;
    },

    pickBeeper(r: number, c: number): void {
      that.beepers[r][c] = that.beepers[r][c] - 1;
    },

    getNumBeepers(r: number, c: number): number {
      return that.beepers[r][c];
    },

    deepCopy(): Beepers {
      const newModel = Beepers(rows, cols);
      newModel.beepers = deepCopyUtil(that.beepers);
      return newModel;
    },
  };

  for (let i = 0; i < rows; i++) {
    that.beepers[i] = [];
    for (let j = 0; j < cols; j++) {
      that.beepers[i][j] = 0;
    }
  }

  return that;
}
